export function useIsActivityAvailable () {
  function isActivityAvailable (activity) {
    return activity.isActive
  }

  return {
    isActivityAvailable
  }
}
